export default "__VITE_ASSET__GVTVJGL1VMtq8AiFX_JFoQ__"